import { Component, inject, signal, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/auth/keycloak/services/auth.service';
import { FidToastService } from '@fid/fid-ui';
import { environment } from '../../../../environments/environment';
import { StorageUtils } from '../../../core/auth/utils/StorageUtils';

@Component({
  selector: 'app-login',
  standalone: false,
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  authService = inject(AuthService);
  private router = inject(Router);
  private toast = inject(FidToastService);

  /** Título parametrizado por proyecto (ej: Portal FIDREN, Portal FIDSIN) */
  appTitle = environment.APP_TITLE;

  // Arranca en true: mientras se resuelve si venimos de un redirect de Keycloak,
  // se muestra el loader en vez del botón de login (evita el parpadeo de la
  // pantalla de login antes de navegar a la página del cliente).
  submitting = signal(true);

  async ngOnInit() {
    // Recoge el resultado de un login por redirección (Keycloak) al volver a esta página.
    try {
      const user = await this.authService.handleIncomingAuth();
      if (user) {
        const target = StorageUtils.pop(StorageUtils.STATE_KEY) || environment.auth_environment.REDIRECT_POST_LOGIN_RUTE;
        this.router.navigateByUrl(target);
        return; // Mantiene el loader visible hasta que se complete la navegación.
      }
    } catch (err) {
      console.error('[Login] Error al resolver el redirect de Keycloak:', err);
      this.toast.show({
        message: 'No se pudo autenticar.\nIntenta nuevamente.',
        type: 'error',
        verticalPosition: 'top',
        horizontalPosition: 'center',
      });
    }

    // No había sesión que retomar (o falló): mostramos el botón de login.
    this.submitting.set(false);
  }

  async signIn() {
    this.submitting.set(true);

    try {
      await this.authService.loginWithKeycloak();

      // En modo popup el login se resuelve aquí mismo (en modo redirect la
      // página ya navegó fuera de la app y esto no se llega a ejecutar).
      if (this.authService.activeAccount()) {
        const target = StorageUtils.pop(StorageUtils.STATE_KEY) || environment.auth_environment.REDIRECT_POST_LOGIN_RUTE;
        this.router.navigateByUrl(target);
      }
    } catch (err) {
      console.error('[Login] Error:', err);
      this.toast.show({
        message: 'No se pudo autenticar.\nIntenta nuevamente.',
        type: 'error',
        verticalPosition: 'top',
        horizontalPosition: 'center',
      });
    } finally {
      this.submitting.set(false);
    }
  }
}
